import { render } from "./GrossProductCreate.vue?vue&type=template&id=2ae0116f"
import script from "./GrossProductCreate.vue?vue&type=script&lang=js"
export * from "./GrossProductCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__